/**
 * Stringify an OpenAPI object. Same API as JSON.stringify.
 */
export function stringifyOpenAPI(value, replacer, space) {
    return JSON.stringify(value, function (key, value) {
        // Ignore internal keys
        if (key.startsWith('x-gitbook-')) {
            return undefined;
        }
        if (replacer) {
            return replacer(key, value);
        }
        return value;
    }, space);
}
